import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, className = "", y = 40 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "", inView = false }) {
  const trigger = inView
    ? { whileInView: { y: "0%" }, viewport: { once: true } }
    : { animate: { y: "0%" } };
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "115%" }}
        {...trigger}
        transition={{ duration: 1, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`font-mono2 text-[10px] sm:text-xs tracking-[0.35em] uppercase text-gold ${className}`}>
      {children}
    </p>
  );
}
